<template>
	<div class="tools-measuring-software-list">
		<div class="tools-measuring-software-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Optical key recognition tool</span>
			</div>

			<div class="list">

				<img :src="solution_image_01" alt="Xhorse"/>

				<ul class="tool-one">
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">
							Use the traditional light source to obtain key parameters such as Key blank shape, biting shape, and, contour. It enables users to greatly improve the speed of the key cutting process.
						</div>
					</li>
				</ul>

				<ul class="tool-two">
					<li><img :src="solution_image_02" alt="Xhorse"/></li>
					<li><img :src="solution_image_03" alt="Xhorse"/></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_optics_06.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_optics_07.png'
    import solution_image_03 from '@/assets/resource/images/solution/image_solutions_optics_08.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
                solution_image_03: solution_image_03
            };
        }
    }

</script>

<style scoped="">
		.tool-two img {
			width: 100%;
		}

		.tool-two > li:nth-child(2) {
			margin-left: 1.5rem;
		}

		.tool-two > li {
			float: left;
			width: calc((100% - 1.5rem) / 2);
			height: 13.25rem;
		}

		.dot {
			width: .625rem;
			border: none;
		}

		.ll {
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.5rem;
			width: calc(100% - .625rem);
			border: none;
		}

		.tool-one > li {
			width: 100%;
			height: 3rem;
		}

		.tool-one {
			height: 3rem;
			margin-bottom: 4rem;
		}

		.list > ul {
			width: 100%;
		}

		.list > img {
			width: 100%;
			margin-bottom: 2.75rem;
		}

		.list {
			width: 54.5rem;
			height: 34.5rem;
			border: none;
			margin-left: 7rem;
		}

		.tools-measuring-software-con {
			width: 61.5rem;
			height: 61.875rem;
			border: none;
			margin-left: 0px;
		}

		.tools-measuring-software-list {
			width: 100%;
			height: 52.25rem;
			border: none;
		}

		.x-tit-con {
			font-size: 1.5rem;
			color: #3B3A38;
			line-height: 3.25rem;
		}

		.title {
			width: calc(100% - 3.25rem);
			text-align: left;
			margin-left: 3.25rem;
			margin-top: 2.75rem;
			margin-bottom: 2.75rem;
		}

		.x-icon-keys {
			display: inline-block;
			content: url("../../../assets/resource/icons/ico_solutions.png");
			width: 2.75rem;
			height: 2.75rem;
			position: relative;
			top: .625rem;
			margin-right: 1rem;
		}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-optical-key-recognition-tool.vue